import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, throwError } from 'rxjs';
import { HttpMethod } from '@core/http/http-method.enum';
import { makeRequest } from '@core/http/resource.utils';
import { API_BASE_URL } from '@shared/constants/api.constants';
import { ContentSearchResponse } from '@spe-content-store/interfaces';
import { GlobalSearchResults } from '@shared/models/search-result.model';
import { compareResultsByTitle, toNuggetResult, toTopicResult } from '@shared/utils/global-search.utils';

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
    private readonly httpClient = inject(HttpClient);

    /** Search runs while typing, so failures are surfaced in the result panel instead of as a toast. */
    public search(term: string): Observable<GlobalSearchResults> {
        return makeRequest<ContentSearchResponse>(
            this.httpClient,
            HttpMethod.GET,
            `${API_BASE_URL}/search`,
            { params: { query: term } },
            error => throwError(() => error)
        ).pipe(
            map(response => ({
                sequences: (response?.topics?.items ?? []).map(toTopicResult).sort(compareResultsByTitle),
                nuggets: (response?.nuggets?.items ?? []).map(toNuggetResult).sort(compareResultsByTitle)
            }))
        );
    }
}
